export const FEE_GET_MULTIPLE =  "FEE_GET_MULTIPLE"
export const FEE_GET_DROPDOWNS =  "FEE_GET_DROPDOWNS"
export const FEE_GET_ONE =  "FEE_GET_ONE"
export const FEE_REGISTER_SUCCESS =  "FEE_REGISTER_SUCCESS"
export const FEE_REGISTER_FAIL =  "FEE_REGISTER_FAIL"
export const FEE_LOADING =  "FEE_LOADING"
export const FEE_LOADING_ERROR =  "FEE_LOADING_ERROR"
export const FEE_ACTIVATE_FAIL =  "FEE_ACTIVATE_FAIL"
export const FEE_ACTIVATE_SUCCESS =  "FEE_ACTIVATE_SUCCESS"
export const FEE_UPDATE_SUCCESS =  "FEE_UPDATE_SUCCESS"
export const FEE_UPDATE_FAIL =  "FEE_UPDATE_FAIL"
export const FEE_DELETE_SUCCESS =  "FEE_DELETE_SUCCESS"
export const FEE_DELETE_FAIL =  "FEE_DELETE_FAIL"
export const FEE_EDIT =  "FEE_EDIT"